import Util from './util';
import refreshService from '../service/login';
const AccessTokenKey = 'jwt_token';
const ExpiresInKey = 'expires_in';
let menuSignArray = [];
let buttonSignArray = [];
export function getAccessToken () {
	let token = sessionStorage.getItem(AccessTokenKey);
	if (Util.isEmpty(token)) {
		token = '';
	}
	return token;
}

export function setAccessToken (token) {
	sessionStorage.setItem(AccessTokenKey, token);
}
export function isAuth(name) {
	let pathArray = JSON.parse(sessionStorage.getItem('menu_sign_array'));
	return pathArray && pathArray.indexOf(name) > -1;
}
export function setAuthTree (tree) {
	sessionStorage.setItem('auth_menu_array', JSON.stringify([]));
	sessionStorage.setItem('auth_menu_array', JSON.stringify(tree));
	// 在设置之前要先清空，因为换账号的时候会存留之前的菜单数据
	// sessionStorage.setItem('menu_sign_array', JSON.stringify([]));
	// sessionStorage.setItem('button_sign_array', JSON.stringify([]));
	// sessionStorage.setItem('auth_menu_array', JSON.stringify([]));
	// if (!tree || tree.length < 1) {
	// 	return;
	// }
	// menuSignArray = [];
	// buttonSignArray = [];
	// let treeMenu = JSON.parse(JSON.stringify(tree));
	// let list = transformMenu(treeMenu);
	// sessionStorage.setItem('menu_sign_array', JSON.stringify(menuSignArray));
	// sessionStorage.setItem('button_sign_array', JSON.stringify(buttonSignArray));
	// sessionStorage.setItem('auth_menu_array', JSON.stringify(list));
}
function transformMenu(list) {
	let allBtn = true;
	list.forEach(menu => {
		menu.type === '10' ? menuSignArray.push(menu.sign) : buttonSignArray.push(menu.sign);
		if (menu.type === '10') {
			allBtn = false;
			menu.menuName = menu.name;
			menu.menuPath = '/icmp' + menu.url;
			if (menu.fields) {
				for (let i = menu.fields.length - 1; i >= 0; i--) {
					if (menu.fields[i].name === 'iconClass') {
						menu.iconClass = menu.fields[i].description;
						break;
					}
				}
			}
			menu.menus = [];
			if (menu.children) {
				menu.menus = menu.children;
			}
			if (menu.children && menu.children.length > 0) {
				menu.menus = transformMenu(menu.children);
			}
		}
	});
	return allBtn ? [] : list;
}

export function removeToken () {
	return sessionStorage.removeItem(AccessTokenKey);
}

export function setExpiresIn (expiresIn) {
	sessionStorage.setItem(ExpiresInKey, expiresIn);
}

export function getExpiresIn () {
	let expiredIn = sessionStorage.getItem(ExpiresInKey);
	if (expiredIn) {
		return parseInt(expiredIn);
	} else {
		return 0;
	}
}

export function removeExpiresIn () {
	return sessionStorage.removeItem(ExpiresInKey);
}

var RefreshTokenTimer;

export function RefreshTokenLoop () {
	let next = parseInt(sessionStorage.getItem('REFRERSH_TOKEN_TIME')); // 25 分钟之后
	if (RefreshTokenTimer) {
		clearTimeout(RefreshTokenTimer);
	}
	RefreshTokenTimer = setTimeout(function () {
		let params = {refreshToken: refreshToken || ''};
		refreshService.refreshToken(params).then(res => {
			if (res.jwt_token) {
				sessionStorage.setItem(AccessTokenKey, res.jwt_token);
			}
		});
		RefreshTokenLoop();
	}, next);
}



// WEBPACK FOOTER //
// ./main/utils/auth.js